module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "itemprop": "containsPlace",
      "itemscope": "",
      "itemtype": "http://schema.org/HotelRoom"
    }
  }, [_c('div', {
    staticClass: "container  ",
    staticStyle: {
      "margin-top": "85px",
      "padding-bottom": "60px"
    }
  }, [_c('h2', {
    attrs: {
      "itemprop": "name"
    }
  }, [_vm._v(_vm._s(_vm.main.name) + " "), _c('b', [_vm._v(_vm._s(_vm.main.price) + " руб. / сут")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 no-padding"
  }, [_c('div', {
    attrs: {
      "id": "adaptive-cafe"
    }
  }, _vm._l((_vm.main.image), function(image) {
    return _c('div', {
      staticClass: "fixed-ar ar-4-3 img "
    }, [_c('div', {
      staticClass: "content",
      style: ('background-image: url(' + image + ')')
    })])
  }), 0), _vm._v(" "), _vm._l((_vm.main.image), function(image) {
    return _c('link', {
      attrs: {
        "itemprop": "photo",
        "href": image
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 no-padding hidden-xs",
    attrs: {
      "itemprop": "description"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.main.description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-container visible-xs"
  }, [_c('div', {
    staticClass: "text-content short-text",
    domProps: {
      "innerHTML": _vm._s(_vm.main.description)
    }
  }), _vm._v(" "), _vm._m(0)])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "2em",
      "padding-right": "0px"
    }
  }, [_c('booking', {
    on: {
      "catChange": _vm.catChange
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-more",
    staticStyle: {
      "display": "block"
    }
  }, [_c('a', {
    staticClass: "booking-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Подробнее")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5606a428"}!./~/vue-loader/lib/selector.js?type=template&index=0!./public/vue/category/modules/Main.vue
// module id = 18
// module chunks = 1 2